import { render, staticRenderFns } from "./unique-feature.html?vue&type=template&id=810ccfd8&scoped=true&"
import script from "./unique-feature.js?vue&type=script&lang=js&"
export * from "./unique-feature.js?vue&type=script&lang=js&"
import style0 from "./unique-feature.scss?vue&type=style&index=0&id=810ccfd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810ccfd8",
  null
  
)

export default component.exports